"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_day_picker_1 = __importDefault(require("react-day-picker"));
const antd_1 = require("antd");
require("react-day-picker/lib/style.css");
require("./RangePickerComponent.scss");
const strings_1 = require("../../assets/strings/strings");
const calendar_icon_svg_1 = __importDefault(require("../../assets/images/calendar-icon.svg"));
function convertToDateFromString(date) {
    const splitDate = date.split('/');
    return new Date(Number(splitDate[2]), Number(splitDate[1]) - 1, Number(splitDate[0]));
}
const RangePickerComponent = ({ name, form, unavailableDates, initialDate, finalDate, loading = false, disabled = false, numberOfMonths = 2, initialLabel = '', finalLabel = '', initialPlaceholder = strings_1.RangePickerComponentStrings.initialDate, finalPlaceholder = strings_1.RangePickerComponentStrings.finalDate, placement = undefined, onChange = () => { }, initialValues = null, }) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [from, setFrom] = (0, react_1.useState)(undefined);
    const [to, setTo] = (0, react_1.useState)(undefined);
    const [convertedDates, setConvertedDates] = (0, react_1.useState)({
        unavailableDates: [],
        initialDate: new Date(1999, 1, 1),
        finalDate: new Date(2999, 1, 1),
    });
    const [initialDisableDays, setInitialDisableDays] = (0, react_1.useState)([
        {
            before: new Date(1999, 1, 1),
            after: new Date(2999, 1, 1),
        },
    ]);
    const [disableDays, setDisableDays] = (0, react_1.useState)(initialDisableDays);
    function hide() {
        setVisible(false);
    }
    function handleVisibleChange(isVisible) {
        if (disabled) {
            setVisible(false);
        }
        else {
            setVisible(isVisible);
        }
    }
    function handleResetClick() {
        setTo(undefined);
        setFrom(undefined);
        setDisableDays(initialDisableDays);
        form.setFieldsValue({ [`initialDate-${name}`]: '' });
        form.setFieldsValue({ [`finalDate-${name}`]: '' });
        onChange('resetChange');
        hide();
    }
    (0, react_1.useEffect)(() => {
        const newConvertedDates = {
            unavailableDates: unavailableDates.map(convertToDateFromString),
            initialDate: convertToDateFromString(initialDate),
            finalDate: convertToDateFromString(finalDate),
        };
        setConvertedDates(newConvertedDates);
        const newInitialDisableDays = [
            ...newConvertedDates.unavailableDates,
            {
                before: newConvertedDates.initialDate,
                after: newConvertedDates.finalDate,
            },
        ];
        setInitialDisableDays(newInitialDisableDays);
        setDisableDays(newInitialDisableDays);
    }, [unavailableDates, initialDate, finalDate]);
    (0, react_1.useEffect)(() => {
        if (initialValues) {
            form.setFieldsValue({ [`initialDate-${name}`]: initialValues.before });
            form.setFieldsValue({ [`finalDate-${name}`]: initialValues.after });
            setFrom(initialValues.before ? convertToDateFromString(initialValues.before) : undefined);
            setTo(initialValues.after ? convertToDateFromString(initialValues.after) : undefined);
        }
    }, [initialValues]);
    function handleDayClick(day, modifiers) {
        if (modifiers.disabled) {
            return;
        }
        let closestBefore = new Date(convertedDates.initialDate);
        let closestAfter = new Date(convertedDates.finalDate);
        closestBefore.setDate(closestBefore.getDate() - 1);
        closestAfter.setDate(closestAfter.getDate() + 1);
        convertedDates.unavailableDates.forEach(date => {
            if (date <= new Date(day) && date > closestBefore) {
                closestBefore = new Date(date);
            }
            if (date >= new Date(day) && date < closestAfter) {
                closestAfter = new Date(date);
            }
        });
        closestBefore.setDate(closestBefore.getDate() + 1);
        closestAfter.setDate(closestAfter.getDate());
        if (!to && from) {
            // Segundo clique
            if (from.toLocaleDateString('pt-BR') === day.toLocaleDateString('pt-BR')) {
                // não permite selecionar o mesmo dia na entrada e na saída
                return;
            }
            if (from > day) {
                form.setFieldsValue({ [`initialDate-${name}`]: day.toLocaleDateString('pt-BR') });
                form.setFieldsValue({ [`finalDate-${name}`]: from.toLocaleDateString('pt-BR') });
                setTo(from);
                setFrom(day);
            }
            else {
                setTo(day);
                form.setFieldsValue({ [`finalDate-${name}`]: day.toLocaleDateString('pt-BR') });
            }
            setDisableDays(initialDisableDays.filter(v => {
                if (v instanceof Date) {
                    return (from.toLocaleDateString('pt-BR') !== v.toLocaleDateString('pt-BR') &&
                        v.toLocaleDateString('pt-BR') !== day.toLocaleDateString('pt-BR'));
                }
                return true;
            }));
            hide();
            onChange('finalDateChange');
        }
        else {
            // Primeiro clique
            setTo(undefined);
            form.setFieldsValue({ [`finalDate-${name}`]: '' });
            // Verifica se é um clique em uma data inicialmente não permitida, ou seja, é uma data somente de checkout
            if (initialDisableDays.find(v => {
                if (v instanceof Date) {
                    return day.toLocaleDateString('pt-BR') === v.toLocaleDateString('pt-BR');
                }
                return false;
            })) {
                setFrom(undefined);
                setDisableDays(initialDisableDays);
                form.setFieldsValue({ [`initialDate-${name}`]: '' });
            }
            else {
                setDisableDays([{ before: closestBefore, after: closestAfter }]);
                setFrom(day);
                form.setFieldsValue({ [`initialDate-${name}`]: day.toLocaleDateString('pt-BR') });
                onChange('initalDateChange');
            }
        }
    }
    return (react_1.default.createElement("div", { className: "RangePickerComponent" },
        react_1.default.createElement(antd_1.Spin, { tip: strings_1.RangePickerComponentStrings.spinLoading, spinning: loading },
            react_1.default.createElement(antd_1.Popover, { overlayClassName: "RangePickerComponent-popover", trigger: "click", visible: visible, onVisibleChange: handleVisibleChange, placement: placement, content: react_1.default.createElement("div", { style: { display: 'block' } },
                    react_1.default.createElement("div", { className: "close-button", onClick: hide }, "X"),
                    react_1.default.createElement(react_day_picker_1.default, { className: "Selectable", numberOfMonths: numberOfMonths, selectedDays: [from, { from, to }], modifiers: { start: from, end: to }, onDayClick: handleDayClick, initialMonth: convertedDates.initialDate, fromMonth: convertedDates.initialDate, toMonth: convertedDates.finalDate, disabledDays: disableDays, locale: "pt", months: strings_1.RangePickerComponentStrings.months, weekdaysLong: strings_1.RangePickerComponentStrings.weekdaysLong, weekdaysShort: strings_1.RangePickerComponentStrings.weekdaysShort, firstDayOfWeek: strings_1.RangePickerComponentStrings.firstDayOfWeek, labels: strings_1.RangePickerComponentStrings.labels }),
                    react_1.default.createElement("div", { className: "clean-button", onClick: handleResetClick }, strings_1.RangePickerComponentStrings.clean)), title: "" },
                react_1.default.createElement("div", { className: "input-container" },
                    react_1.default.createElement(antd_1.Form.Item, { className: "date-input", name: `initialDate-${name}`, label: initialLabel, getValueFromEvent: () => (from ? from.toLocaleDateString('pt-BR') : '') },
                        react_1.default.createElement(antd_1.Input, { autoComplete: "off", placeholder: initialPlaceholder, suffix: react_1.default.createElement("img", { src: calendar_icon_svg_1.default, alt: "", style: { width: 15 } }), disabled: disabled, onFocus: (e) => { e.target.blur(); } })),
                    react_1.default.createElement(antd_1.Form.Item, { className: "date-input", name: `finalDate-${name}`, label: finalLabel, getValueFromEvent: () => (to ? to.toLocaleDateString('pt-BR') : '') },
                        react_1.default.createElement(antd_1.Input, { placeholder: finalPlaceholder, suffix: react_1.default.createElement("img", { src: calendar_icon_svg_1.default, alt: "", style: { width: 15 } }), disabled: disabled, onFocus: (e) => { e.target.blur(); } })))))));
};
exports.default = RangePickerComponent;
